module.exports = __webpack_public_path__ + "static/media/sun-icon.07bdb08a.svg";